import { render } from "./index.vue?vue&type=template&id=21494382&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=21494382&scoped=true&lang=css"

import exportComponent from "F:\\Program\\JAVA\\JavaProject\\DXD物流系统\\logisticsWeb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21494382"]])

export default __exports__